import { REQUEST, SUCCESS } from '../../../utils/actionGenerator';
import { fork, take, all, call, put, takeLatest } from 'redux-saga/effects';
import { urls } from '../../../utils/urls';
import * as api from '../../../utils/api';
import { fetchEntity, fetchEntitySpawn } from '../../../store/saga';
import * as consignerActions from './actions';
import { getEnv } from 'utils/utils';
import { getCookie } from 'utils/cookies';
import store from 'store/configureStore';
import { SET_LOADER } from 'components/App/store/actions';
import { showToaster } from 'components/Toaster/action';
// import { get } from 'lodash';

export function* getConsigners(params) {
  const request = api.consignerRequest.bind(null, params);
  yield fetchEntity(request, consignerActions.allConsigners, params);
}

export function* getVpaDetails(params) {
  const request = api.vpaDetailsRequest.bind(null, params);
  yield fetchEntity(request, consignerActions.getVpaDetails, params);
}

export function* getSearchResults(params) {
  const request = api.searchResultsRequest.bind(null, params);
  yield fetchEntity(request, consignerActions.getSearchResults, params);
}

export function* getConsignerType() {
  const request = api.consignerTypeRequest.bind();
  yield fetchEntity(request, consignerActions.getConsignerType, null);
}

export function* getConsignerStatus() {
  const request = api.consignerStatusRequest.bind();
  yield fetchEntity(request, consignerActions.getConsignerStatus, null);
}

export function* viewFile(file) {
  const request = api.viewFileRequest.bind(null, file);
  yield fetchEntity(request, consignerActions.viewFile, null);
}

export function* fetchConsignerDetails(params) {
  let requests = [
    api.consignerByCodeRequest.bind(null, params.id),
    // api.vpaByCodeRequest.bind(null, params.code),
    api.addressByCodeRequest.bind(null, params.code),
    // api.gstByCodeRequest.bind(null, params.code),
    // api.getWalletbalance.bind(null,params.code)
  ];

  try {
    const responses = yield all(requests.map((fn) => call(fn)));
    yield put(consignerActions.consignerDetails.success(responses));
  } catch (error) {
    yield put(consignerActions.consignerDetails.failure({}));
    // log error
  }
}

export function* getUploadGstUrl(params) {
  try {
    const response = yield call(uploadGstFile, params);
    if (response.ok) yield put(consignerActions.uploadGst.success(response, params));
  } catch (err) {
    console.log(err);
  }
}

export function* uploadConsignerFile(params) {
  try {
    const response = yield call(uploadConsignerData, params);
    if (response.ok) yield put(consignerActions.uploadConsignerFile.success(response, params));
  } catch (err) {
    console.log(err);
  }
}

export function* viewGstUrl(params) {
  const request = api.viewGstUrlRequest.bind(null, params);
  yield fetchEntity(request, consignerActions.viewGst, params);
}

export function* viewConsignerFile(params) {
  const request = api.viewConsignerFileRequest.bind(null, params);
  yield fetchEntity(request, consignerActions.viewConsignerFile, params);
}

function uploadGstFile(params) {
  let requestParams = { ...params };
  let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return fetch(
    `${urls.getUploadGstUrl}?gstNumber=${requestParams.gstNum}&consignerCode=${requestParams.cCode}`,
    headers,
  )
    .then((response) => response.json())
    .then((response) => {
      return fetch(response.data.uploadUrl, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/octet-stream',
          ...headers,
        },
        body: requestParams.formData,
      });
    })
    .then((res) => {
      return res;
    });
}

function uploadConsignerData(params) {
  let requestParams = { ...params };
  let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  return fetch(
    `${urls.uploadConsignerFile}?docType=${requestParams.docType}&consignerCode=${requestParams.cCode}`,
    headers,
  )
    .then((response) => response.json())
    .then((response) => {
      return fetch(response.data, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/octet-stream',
          ...headers,
        },
        body: requestParams.formData,
      });
    })
    .then((res) => {
      return res;
    });
}

export function* createConsigner(payload) {
  const request = api.createConsignerRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.createConsigner, payload);
}

export function* editCompliances(payload) {
  const request = api.editCompliancesRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.editCompliances, payload);
}

export function* editPayment(payload) {
  const request = api.editPaymentRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.editPayment, payload);
}

export function* editBusiness(payload) {
  const request = api.editBusinessRequest.bind(null, payload.payload);
  yield fetchEntity(request, consignerActions.editBusiness, payload.payload);
}

export function* editNotification(payload) {
  const request = api.editNotificationRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.editNotification, payload);
}

export function* uploadDocument(payload) {
  const request = api.uploadDocumentRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.uploadDocument, payload);
}

export function* saveEditedAddress(payload) {
  const request = api.saveEditedAddressRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.saveEditedAddress, payload);
}

export function* editBasicDetails(payload) {
  const request = api.editBasicDetailsRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.editBasicDetails, payload);
}

export function* editVpaDetails(payload) {
  const request = api.editVpaDetailsRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.editVpaDetails, payload);
}

export function* createVpaDetails(payload) {
  const request = api.createVpaDetailsRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.createVpaDetails, payload);
}

export function* createNewAddress(payload) {
  const request = api.createNewAddressRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.createNewAddress, payload);
}

export function* saveConsignerGst(payload) {
  const request = api.saveConsignerGstRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.saveConsignerGst, payload);
}

export function* createConsignerGst(payload) {
  const request = api.createConsignerGstRequest.bind(null, payload);
  yield fetchEntity(request, consignerActions.createConsignerGst, payload);
}

export function* deletePoc(id) {
  const request = api.deletePocRequest.bind(null, id);
  yield fetchEntity(request, consignerActions.deletePoc, id);
}

export function* deleteAddress(id) {
  const request = api.deleteAddressRequest.bind(null, id);
  yield fetchEntity(request, consignerActions.deleteAddress, id);
}

export function* deleteGst(id) {
  const request = api.deleteGstRequest.bind(null, id);
  yield fetchEntity(request, consignerActions.deleteGst, id);
}

/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
export function* watchGetConsignersSaga() {
  while (true) {
    const { params } = yield take(consignerActions.GET_CONSIGNERS[REQUEST]);
    yield fork(getConsigners, params);
  }
}

export function* watchGetConsignerTypeSaga() {
  while (true) {
    yield take(consignerActions.GET_CONSIGNER_TYPE[REQUEST]);
    yield fork(getConsignerType);
  }
}

export function* watchGetConsignerStatusSaga() {
  while (true) {
    yield take(consignerActions.GET_CONSIGNER_STATUS[REQUEST]);
    yield fork(getConsignerStatus);
  }
}

export function* watchViewFileSaga() {
  while (true) {
    const { file } = yield take(consignerActions.VIEW_FILE[REQUEST]);
    yield fork(viewFile, file);
  }
}

export function* watchFetchConsignerDetailsSaga() {
  while (true) {
    const { params } = yield take(consignerActions.GET_CONSIGNER_DETAILS[REQUEST]);
    yield fork(fetchConsignerDetails, params);
  }
}

export function* watchGetSearchResultsSaga() {
  while (true) {
    const { params } = yield take(consignerActions.GET_SEARCH_RESULTS[REQUEST]);
    yield fork(getSearchResults, params);
  }
}

export function* watchGetVpaDetailsSaga() {
  while (true) {
    const { params } = yield take(consignerActions.GET_VPA_DETAILS[REQUEST]);
    yield fork(getVpaDetails, params);
  }
}

export function* watchGetUploadGstUrl() {
  while (true) {
    const { params } = yield take(consignerActions.UPLOAD_GST[REQUEST]);
    yield fork(getUploadGstUrl, params);
  }
}

export function* watchUploadConsignerFileSaga() {
  while (true) {
    const { params } = yield take(consignerActions.UPLOAD_CONSIGNER_FILE[REQUEST]);
    yield fork(uploadConsignerFile, params);
  }
}

export function* watchViewGstUrlSaga() {
  while (true) {
    const { params } = yield take(consignerActions.VIEW_GST[REQUEST]);
    yield fork(viewGstUrl, params);
  }
}

export function* watchViewConsignerFileSaga() {
  while (true) {
    const { params } = yield take(consignerActions.VIEW_CONSIGNER_FILE[REQUEST]);
    yield fork(viewConsignerFile, params);
  }
}

export function* watchCreateConsignerSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.CREATE_CONSIGNER[REQUEST]);
    yield fork(createConsigner, payload);
  }
}

export function* watchEditCompliancesSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.EDIT_COMPLIANCES[REQUEST]);
    yield fork(editCompliances, payload);
  }
}

export function* watchEditPaymentSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.EDIT_PAYMENT[REQUEST]);
    yield fork(editPayment, payload);
  }
}

export function* watchEditBusinesstSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.EDIT_BUSINESS[REQUEST]);
    yield fork(editBusiness, payload);
  }
}

export function* watchEditNotificationSaga() {
  const { payload } = yield take(consignerActions.EDIT_NOTIFICATION[REQUEST]);
  yield fork(editNotification, payload);
}

export function* watchUploadDocumentSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.UPLOAD_DOCUMENT[REQUEST]);
    yield fork(uploadDocument, payload);
  }
}

export function* watchSaveEditedAddressSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.SAVE_ADDRESS[REQUEST]);
    yield fork(saveEditedAddress, payload);
  }
}

export function* watchEditBasicDetailsSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.EDIT_BASIC_DETAILS[REQUEST]);
    yield fork(editBasicDetails, payload);
  }
}

export function* watchEditVpaDetailsSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.EDIT_VPA_DETAILS[REQUEST]);
    yield fork(editVpaDetails, payload);
  }
}

export function* watchCreateVpaDetailsSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.CREATE_VPA_DETAILS[REQUEST]);
    yield fork(createVpaDetails, payload);
  }
}

export function* watchCreateNewAddressSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.CREATE_ADDRESS[REQUEST]);
    yield fork(createNewAddress, payload);
  }
}

export function* watchSaveConsignerGstSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.SAVE_GST[REQUEST]);
    yield fork(saveConsignerGst, payload);
  }
}

export function* watchCreateConsignerGstSaga() {
  while (true) {
    const { payload } = yield take(consignerActions.CREATE_GST[REQUEST]);
    yield fork(createConsignerGst, payload);
  }
}

export function* watchDeletePocSaga() {
  while (true) {
    const { id } = yield take(consignerActions.DELETE_POC[REQUEST]);
    yield fork(deletePoc, id);
  }
}

export function* watchDeleteAddressSaga() {
  while (true) {
    const { id } = yield take(consignerActions.DELETE_ADDRESS[REQUEST]);
    yield fork(deleteAddress, id);
  }
}

export function* watchDeleteGstSaga() {
  while (true) {
    const { id } = yield take(consignerActions.DELETE_GST[REQUEST]);
    yield fork(deleteGst, id);
  }
}

export function* fetchConsignerBillingDetails(actions) {
  const request = api.consignerBillingDetails(actions.params);
  yield fetchEntitySpawn(request, consignerActions.consignerBillingDetails, actions.params);
}

export function* updateBillingAccount(actions) {
  const request = api.updateConsignerBillingAccount(actions.payload);
  yield fetchEntitySpawn(request, consignerActions.updateBillingAccount, actions.payload);
}

export function* updatePanGst(actions) {
  if (actions.payload.onlyType === 'createPanGst') {
    const request = api.createConsignerPanGst(actions.payload.payload);
    yield fetchEntitySpawn(request, consignerActions.updatePanGst, actions.payload.payload);
  } else {
    const request = api.updateConsignerPanGst(actions.payload.payload);
    yield fetchEntitySpawn(request, consignerActions.updatePanGst, actions.payload.payload);
  }
}

export function* viewPreSignedUrl(actions) {
  const request = api.viewPreSignedUrl(actions.payload);
  yield fetchEntitySpawn(request, consignerActions.viewPreSignedUrl, actions.payload);
}

export function* uploadPreSignedUrl(actions) {
  const request = api.uploadPreSignedUrl(actions.payload);
  yield fetchEntitySpawn(request, consignerActions.uploadPreSignedUrl, {
    ...actions.payload,
    isChainedRequest: true,
    chainedRequestData: actions.payload,
  });
}

// export function* uploadPreSignedUrl(actions) {
//   try {
//     const response = yield call(uploadFileAtPreSignedUrl, actions.payload);
//     if (response.ok) yield put(consignerActions.uploadPreSignedUrl.success(response, actions.payload));
//   } catch (err) {
//     console.log(err);
//   }
// }

function* uploadFileAtPreSignedUrl(actions) {
  const url = actions?.response?.response?.data?.frontImgUrl ?? '';
  const payload = actions?.response?.chainedRequestData ?? {};
  const { formData } = payload;
  const request = api.uploadToPreSignedUrl(url, formData);
  yield fetchEntitySpawn(request, consignerActions.uploadToPreSignedUrl, {
    toaster: { successMsg: 'File uploaded succesfully', errorMsg: 'Unable to upload file' },
    isFileUpload: true,
    formData,
  });
  // const request = api.uploadToPreSignedUrl()

  // let requestParams = { ...params };
  // let headers = getEnv() === 'prod' ? {} : { 'X-GOOGLE-TOKEN': getCookie('googleAuth') };
  // return fetch(
  //   `${urls.uploadPreSignedUrl}?documentType=${requestParams.documentType}&fileExtension=${requestParams.fileExtension}`,
  //   headers,
  // )
  //   .then((response) => response.json())
  //   .then((response) => {
  //     return fetch(response.data.frontImgUrl, {
  //       method: 'PUT',
  //       headers: {
  //         'Content-Type': 'application/octet-stream',
  //         ...headers,
  //       },
  //       body: requestParams.formData,
  //     });
  //   })
  //   .then((res) => {
  //     return res;
  //   });
}

export function* fetchConsignerTransactionsList(actions) {
  const request = api.consignerTransactionsList(actions.params);
  yield fetchEntitySpawn(request, consignerActions.consignerTransactionsListActionNew, actions.params);
}

export function* fetchCashBackType(actions) {
  const request = api.cashBackType(actions.params);
  yield fetchEntitySpawn(request, consignerActions.getCashBackTypeAction, actions.params);
}

export function* addNewTransactionSaga(actions) {
  const request = api.addNewTransactionApi(actions.payload);
  yield fetchEntitySpawn(request, consignerActions.addNewTransactionAction, actions.payload);
}

export function* fetcWalletBalance(actions) {
  const request = api.getWalletbalance(actions.params);
  yield fetchEntitySpawn(request, consignerActions.getWalletBalance, actions.params);
}

export function* postConfirmation(action) {
  const request = api.submitConfirmationRequest(action.params);
  yield fetchEntitySpawn(request, consignerActions.submitConfirmation, {
    toaster: { successMsg: 'Updated Successfully!', errorMsg: 'Something went wrong' },
  });
}

export function* getConsignerPaymentModes(action) {
  const request = api.getUpdateConsignerPaymentModeOptions.bind(null, action.params);
  yield fetchEntity(request, consignerActions.getConsignerPaymentModes, action.params);
}

export function* getConsignerBusinessDetails(action) {
  const request = api.getConsignerBusinessDetails.bind(null, action.params);
  yield fetchEntity(request, consignerActions.getConsignerBusinessDetails, action.params);
}

// export function* watchUploadFileDocumentSaga() {
//   while (true) {
//     const { payload } = yield take(consignerActions.UPLOAD_PAYMENT_DOC[REQUEST]);
//     yield fork(uploadDocument, payload);
//   }
// }

// export function* uploadDoc(payload) {
//   const formData = {
//     fileName: payload.params.formData.name,
//     type: payload.params.docType,
//   };

//   let requests = [api.uploadPostDocumentRequest.bind(null, formData)];

//   try {
//     store.dispatch({ type: SET_LOADER });
//     const responses = yield all(requests.map((fn) => call(fn)));

//     if (responses[0].data.message === 'Ok') yield put(consignerActions.uploadDocument.success(responses, payload));
//     const uploadUrl = responses[0].data.data.url;
//     let presignedUrl = uploadUrl.toString();
//     console.log(payload.params, 'payload.params');
//     if (responses) {
//       fetch(` ${presignedUrl}`, {
//         headers: { Accept: 'application/json, text/plain, /' },
//         method: 'PUT',
//         body: payload.params.formData,
//       })
//         .then((response) => {
//           // response.json();
//           if (response.status === 200) {
//             put(showToaster({ toasterMsg: 'Successfully uploaded', toasterType: 'success' }));
//           }
//         })
//         .then((data) => {
//           put(showToaster({ toasterMsg: data.message ?? 'Successfully uploaded', toasterType: 'success' }));
//         })
//         .catch((error) => {
//           put(showToaster({ toasterMsg: error.message ?? 'Something went wrong', toasterType: 'error' }));
//         });
//     }
//   } catch (err) {
//     store.dispatch({ type: SET_LOADER });
//     yield put(showToaster({ toasterMsg: err.message ?? 'Something went wrong', toasterType: 'error' }));
//   } finally {
//     store.dispatch({ type: SET_LOADER });
//   }
// }

export function* uploadDoc(payload) {
  const formData = {
    fileName: payload.params.formData.name,
    type: payload.params.docType,
  };

  let requests = [api.uploadPostDocumentRequest.bind(null, formData)];

  try {
    store.dispatch({ type: SET_LOADER });
    const responses = yield all(requests.map((fn) => call(fn)));

    if (responses[0].data.message === 'Ok') yield put(consignerActions.uploadDocument.success(responses, payload));
    const uploadUrl = responses[0].data.data.url;
    let presignedUrl = uploadUrl.toString();

    const response = yield call(fetch, presignedUrl, {
      headers: { Accept: 'application/json, text/plain, /' },
      method: 'PUT',
      body: payload.params.formData,
    });

    if (response.status === 200) {
      yield put(showToaster({ toasterMsg: 'Successfully uploaded', toasterType: 'success' }));
    } else {
      const errorData = yield response.json();
      yield put(showToaster({ toasterMsg: errorData.message ?? 'Something went wrong', toasterType: 'error' }));
    }
  } catch (err) {
    store.dispatch({ type: SET_LOADER });
    yield put(showToaster({ toasterMsg: err.message ?? 'Something went wrong', toasterType: 'error' }));
  } finally {
    store.dispatch({ type: SET_LOADER });
  }
}

export function* viewUploadedDocument(params) {
  if (!!params) {
    params.resourceKey = params.docCode;
    let requests = [api.getUploadedDocumentUrlRequest2.bind(null, params)];

    try {
      const responses = yield all(requests.map((fn) => call(fn)));
      if (params.openType == 'window') {
        if (responses[0].data.message === 'Ok') {
          window.open(responses[0].data.data.url, '_blank');
        }
      } else {
        yield put(consignerActions.getViewImageUrl.success(responses, params));
      }
    } catch (error) {
      //log(error)
    }
  }
}

export function* watchGetImageUrlSaga1() {
  while (true) {
    const { params } = yield take(consignerActions.GET_PAYMENT_IMAGE_URL[REQUEST]);
    yield fork(viewUploadedDocument, params);
  }
}

function* consignerSaga() {
  yield takeLatest(consignerActions.GET_CONSIGNER_BILLING_DETAILS[REQUEST], fetchConsignerBillingDetails);
  yield takeLatest(consignerActions.UPDATE_BILLING_ACCOUNT[REQUEST], updateBillingAccount);
  yield takeLatest(consignerActions.UPDATE_PAN_GST[REQUEST], updatePanGst);
  yield takeLatest(consignerActions.VIEW_PRE_SIGNED_URL[REQUEST], viewPreSignedUrl);
  yield takeLatest(consignerActions.UPLOAD_PRE_SIGNED_URL[REQUEST], uploadPreSignedUrl);
  yield takeLatest(consignerActions.UPLOAD_PRE_SIGNED_URL[SUCCESS], uploadFileAtPreSignedUrl);
  yield takeLatest(consignerActions.GET_CONSIGNERS_TRANCATION_LIST_NEW[REQUEST], fetchConsignerTransactionsList);

  yield takeLatest(consignerActions.GET_CASHBACK_TYPE[REQUEST], fetchCashBackType);

  yield takeLatest(consignerActions.GET_WALLET_BALANCE[REQUEST], fetcWalletBalance);

  yield takeLatest(consignerActions.ADD_NEW_TRANSACTION[REQUEST], addNewTransactionSaga);
  yield takeLatest(consignerActions.GET_PAYMENT_SELECTION_TYPES[REQUEST], getConsignerPaymentModes);
  yield takeLatest(consignerActions.GET_BUSINESS_DETAILS[REQUEST], getConsignerBusinessDetails);
  yield takeLatest(consignerActions.UPLOAD_PAYMENT_DOC[REQUEST], uploadDoc);
  yield takeLatest(consignerActions.SUBMIT_CONFIRMATION[REQUEST], postConfirmation);
}

export default consignerSaga;

// addNewTransactionAction
